import { useEffect, useRef, useState } from "react";
import { ScanBarcode, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import BarcodeScanner from "@/components/BarcodeScanner";

/** Always-focused input for wedge scanners + camera scan + manual add. */
export default function StockTakeScanBar({ onScan, onManual, paused }) {
  const [code, setCode] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    if (!paused) setTimeout(() => ref.current?.focus(), 50);
  }, [paused]);

  const submit = () => {
    const v = code.trim();
    if (!v) return;
    setCode("");
    onScan(v);
  };

  return (
    <div className="panel p-4 sm:p-5 border-2 border-dashed border-primary/40" data-testid="stocktake-scan-bar">
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] font-bold text-stone-500 mb-2">
        <ScanBarcode className="h-4 w-4 text-primary" /> Scan each bag, tub or pallet
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <Input
          ref={ref}
          value={code}
          onChange={(e) => setCode(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              submit();
            }
          }}
          placeholder="Scan barcode or type supplier batch, then Enter"
          className="h-14 text-lg font-mono flex-1"
          autoComplete="off"
          data-testid="stocktake-scan-input"
        />
        <div className="flex gap-2">
          <Button className="h-14 px-5" onClick={submit} data-testid="stocktake-scan-submit">Find</Button>
          <BarcodeScanner onScan={(v) => onScan(v)} label="Camera" />
          <Button variant="outline" className="h-14 px-4 gap-1.5" onClick={onManual} data-testid="stocktake-manual-add">
            <Plus className="h-4 w-4" /> Manual
          </Button>
        </div>
      </div>
    </div>
  );
}
